import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { CmpsAccordionItemComponent } from '@cmps/ng-uikit';

import { CaGroup, CaResult } from '../core';

@Component({
    selector: 'cmps-ca-evaluation',
    templateUrl: './ca-evaluation.component.html',
    host: {
        class: 'cmps-ca-evaluation',
    },
})
export class CaEvaluationComponent {
    @ViewChildren(CmpsAccordionItemComponent)
    private readonly _items: QueryList<CmpsAccordionItemComponent>;

    @Input() get caResult(): CaResult {
        return this._caResult;
    }

    set caResult(value: CaResult) {
        this._caResult = value;
        this._checkCollapsedState();
        this._checkOneCollapsed();
    }

    @Input() get collapsed(): boolean {
        return this._collapsed;
    }

    set collapsed(value: boolean) {
        const manual = this._collapsed === value;
        this._collapsed = value;
        if (manual) {
            // TODO fix CmpsAccordionItemComponent
            this._items?.forEach((e) =>
                this._collapsed ? e.close() : e.open(),
            );
        }
        this._checkCollapsedState();
        this._checkOneCollapsed();
    }

    /** @private */ _collapsedState: { [key: string]: boolean };
    /** @private */ _caResult: CaResult;
    /** @private */ _collapsed: boolean;
    atLeastOneCollapsed: boolean;

    /** @private */
    _onHeaderClick(group: CaGroup, collapsed: boolean): void {
        this._collapsedState[group.label] = collapsed;
        this._checkCollapsed();
        this._checkOneCollapsed();
    }

    private _checkCollapsedState(): void {
        const nextCollapsedState: { [key: string]: boolean } = {};
        this.caResult?.groups?.map(
            (e) => (nextCollapsedState[e.label] = this._collapsed),
        );
        this._collapsedState = nextCollapsedState;
    }

    private _checkCollapsed(): void {
        const allCollapsed = Object.values(this._collapsedState).every(
            (e) => e,
        );
        if (allCollapsed) {
            this._collapsed = true;
        }

        const allNotCollapsed = Object.values(this._collapsedState).every(
            (e) => !e,
        );
        if (allNotCollapsed) {
            this._collapsed = false;
        }
    }

    private _checkOneCollapsed(): void {
        this.atLeastOneCollapsed = Object.values(this._collapsedState).some(
            (e) => e,
        );
    }
}
